import { render, staticRenderFns } from "./FocusAreaList.vue?vue&type=template&id=73f9637c&"
import script from "./FocusAreaList.vue?vue&type=script&lang=js&"
export * from "./FocusAreaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports